"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.directMessages.loadFailed': 'Nie udało się załadować wiadomości bezpośrednich.',
    'whatsapp.directMessages.search': 'Szukaj kontaktów...',
    'whatsapp.directMessages.contacts': 'Kontakty',
    'whatsapp.directMessages.noContacts': 'Nie znaleziono kontaktów z wiadomościami bezpośrednimi.',
    'whatsapp.directMessages.trackLogs': 'Logi śledzenia',
    'whatsapp.directMessages.selectContact': 'Wybierz kontakt, aby wyświetlić logi śledzenia.',
    'whatsapp.directMessages.noLogs': 'Brak logów śledzenia dla tego kontaktu.',
    'whatsapp.directMessages.viewDetails': 'Zobacz szczegóły',
};
